import { motion } from "framer-motion";
import { Nav } from "@/components/Nav";
import { Factory } from "@/components/Factory";
import { Hotspots } from "@/components/Hotspots";
import { Benefits } from "@/components/Benefits";
import { Footer } from "@/components/Footer";

const EASE = [0.16, 1, 0.3, 1];

const FACTORY_POINTS = [
  "Assembled by robots, finished and inspected by hand",
  "Over 100 quality checks before any Hub ships",
  "Built under ISO 13485 medical manufacturing standards",
  "Every unit self-tests each morning before the doors open",
  "Parts are traceable end to end, from sensor to screen",
];

export default function FactoryPage() {
  return (
    <main data-testid="factory-page">
      <Nav />

      <section className="pt-36 sm:pt-44 pb-20 px-6 sm:px-12 max-w-3xl mx-auto text-center">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: EASE, delay: 0.3 }}
          className="font-mono2 text-[11px] uppercase tracking-[0.35em] text-[#808080]"
        >
          Factory
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: EASE, delay: 0.4 }}
          className="font-display font-semibold tracking-tight text-[#3A3A3C] text-4xl sm:text-5xl mt-4 leading-[1.1]"
          data-testid="factory-title"
        >
          Where every Hub is born.
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: EASE, delay: 0.55 }}
          className="text-base text-[#474747] leading-relaxed mt-6"
        >
          Medical devices earn trust the slow way — one test at a time. Here's how each Hub is made,
          checked and checked again.
        </motion.p>
      </section>

      <Factory />
      <Hotspots />
      <Benefits title="How every Hub is made." items={FACTORY_POINTS} testid="factory-benefits" />

      <Footer />
    </main>
  );
}
